module.exports = __webpack_public_path__ + "static/img/dreamWispNasalMask.c5f5daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/dreamWispNasalMask.png
// module id = m15M
// module chunks = 1